// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appVersion: 'v726demo1',
  USERDATA_KEY: 'authf649fc9a5f55',
  // apiUrl: 'https://localhost:7285/api',
  // patchUrl: 'https://localhost:7285',
  apiUrl: 'https://api.lamadrivingschool.com/api',
  patchUrl: 'https://api.lamadrivingschool.com',

  googleClientId: '542764586420-o198211vnt1cm7ufoafs8vruj3ckiul5.apps.googleusercontent.com',


  // apiUrl: 'https://localhost:7285/api',
  // patchUrl: 'https://localhost:7285',

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
